import ReactDOM from "react-dom/client";
import { App } from "./App";

function init() {
  const container = document.querySelector(".js-ai-image-generation");

  if (!container) {
    return;
  }

  const productCatalogNumber = container.getAttribute("data-product");

  ReactDOM.createRoot(container).render(<App productCatalogNumber={productCatalogNumber} />);
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});
